import { useMutation } from "@apollo/client/react";
import React, { useState, useMemo, useEffect } from 'react';
import { TratamientoInput } from "./TratamientoInput";
import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";
import CardBox from "../../CardBox/CardBox";
import { useVisita } from "../../../../../../context/VisitaContext";
import { SAVE_VISITA_CP_TRATAMIENTOS, adaptVisitaCPTratamientosInput } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaCP";



export const TratamientoCP = ({ readOnly, onSaveRef, onExposeFormatted }) => {
  const [formData, setFormData] = useState({});
  const { visita, setVisita } = useVisita();
  const [childrenAction, setChildrenAction] = useState(null);

  const [save] = useMutation(SAVE_VISITA_CP_TRATAMIENTOS);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, "tratamientos": value }));
  };

  useStepSave(onSaveRef, async (validate) => {
    const { data } = await save({
      variables: { input: adaptVisitaCPTratamientosInput(formData) }
    });

    setVisita((prev) => ({ ...prev, ...formData }));
  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  // useEffect(() => {
  //     onExposeFormatted?.({
  //         stepId: "tratamientoCP",
  //         stepName: "Tratamiento",
  //         formattedInputs,
  //     });
  // }, [onExposeFormatted, formattedInputs]);
  return (
    <CardBox>
            <div className='step-form-section-container' key={'Tratamiento'}>
                <label className={`step-form-section-title ${childrenAction ? 'with-children-action' : ''}`}>
                    {'Tratamiento'}{Boolean(childrenAction) && childrenAction}
                </label>

                <TratamientoInput
          handleChange={handleChange}
          prevTratamientos={formData?.tratamientos}
          setChildrenAction={setChildrenAction}
          fieldName='tratamientos'
          readOnly={readOnly} />
        
            </div>
        </CardBox>);

};